import React, { useEffect, useState } from 'react';
import { List, Divider, Spin, Empty, Avatar, Badge } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../api.js';

export default function MessagesDropdown({ onClose, open }) {
  const [inbox, setInbox] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      fetchInbox();
    }
  }, [open]);

  const fetchInbox = async () => {
    try {
      setLoading(true);
      const res = await api.get('/messages/inbox');
      setInbox(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (conv) => {
    try {
      if (conv.unreadCount > 0) {
        await api.put(`/messages/read/${conv.carId}/${conv.otherUserId}`);
      }
    } catch (err) {
      console.error(err);
    } finally {
      navigate('/Messages', { state: { carId: conv.carId, otherUserId: conv.otherUserId } });
      if (onClose) onClose();
    }
  };

  return (
    <div style={{ width: 320, background: '#fff', borderRadius: 10 }}>
      <div style={{ padding: 10, fontWeight: 600 }}>
        {t('chat') || 'Messages'}
      </div>

      <Divider style={{ margin: 0 }} />

      {loading ? (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Spin />
        </div>
      ) : inbox.length === 0 ? (
        <div style={{ padding: 20 }}>
          <Empty description={t('noMessages') || 'Aucun message'} />
        </div>
      ) : (
        <List
          style={{ maxHeight: 360, overflowY: 'auto' }}
          dataSource={inbox}
          renderItem={(conv) => (
            <List.Item
              onClick={() => handleClick(conv)}
              style={{
                cursor: 'pointer',
                background: conv.unreadCount > 0 ? '#f5f5f5' : '#fff',
                padding: 12,
              }}
            >
              <List.Item.Meta
                avatar={
                  <Badge count={conv.unreadCount || 0} size="small">
                    <Avatar style={{ backgroundColor: '#5F41E4' }}>
                      {(conv.senderName || '?')[0].toUpperCase()}
                    </Avatar>
                  </Badge>
                }
                title={conv.senderName}
                description={
                  <>
                    <div style={{ fontSize: 12, color: '#999' }}>{conv.carTitle}</div>
                    <div
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 220,
                      }}
                    >
                      {conv.lastMessage}
                    </div>
                  </>
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
}
